module.exports = __webpack_public_path__ + "img/ai-chat-history-cmp-icon.66c5e49c.svg";